import styled from "styled-components";
import { pxToRem } from "../../styles/utils";

export const LessonDetailsContainer = styled.div`
  padding: ${pxToRem(20)};
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(20)};
  background: white;
  border-radius: ${pxToRem(16)};
  margin: ${pxToRem(20)} 0;
  box-shadow: 0px ${pxToRem(4)} ${pxToRem(8)} rgba(0, 0, 0, 0.1);
  max-height: calc(100vh - ${pxToRem(300)});
  overflow-y: auto;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }
`;

export const LessonDescription = styled.p`
  color: rgb(31, 10, 53);
  font-size: ${pxToRem(18)};
  font-weight: 400;
`;

export const LessonCategory = styled.p`
  color: rgb(31, 10, 53);
  font-size: ${pxToRem(18)};
  font-weight: 400;
`;

export const LessonLink = styled.a`
  color: rgb(114, 82, 220);
  font-size: ${pxToRem(18)};
  font-weight: 400;
  text-decoration: none;

  &:hover {
    text-decoration: none;
  }
`;

export const LessonFiles = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${pxToRem(8)};

  a {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: ${pxToRem(16)};
    background: rgb(235, 235, 235);
    width: ${pxToRem(87)};
    height: ${pxToRem(87)};
    text-decoration: none;
    padding: ${pxToRem(12)};
    color: rgb(0, 0, 0);
    font-size: ${pxToRem(14)};
    font-weight: 400;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  span {
    text-overflow: ellipsis;
    overflow: hidden;
    width: ${pxToRem(60)};
  }
`;

export const FileIcon = styled.img`
  width: ${pxToRem(30)};
  height: ${pxToRem(30)};
`;

export const AddMaterialLink = styled.span`
  display: block;
  text-align: center;
  color: rgb(114, 82, 220);
  font-size: ${pxToRem(18)};
  font-weight: 700;
  cursor: pointer;
  padding: ${pxToRem(12)} ${pxToRem(12)} ${pxToRem(12)} 0;
  border: ${pxToRem(1)} solid rgb(114, 82, 220);
  border-radius: ${pxToRem(12)};
  margin-bottom: ${pxToRem(40)};
`;

export const ActionIconsWrapper = styled.div<{ isEditing?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${pxToRem(30)};
  border: ${pxToRem(1)} solid ${({ isEditing }) => (isEditing ? "rgb(114, 82, 220)" : "rgba(31, 10, 53, 0.1)")};
  border-radius: ${pxToRem(16)};
  padding: ${pxToRem(20)};
  background-color: ${({ isEditing }) => (isEditing ? "rgba(114, 82, 220, 0.05)" : "transparent")};
  transition: all 0.3s ease;

  img {
    cursor: pointer;
    margin-left: ${pxToRem(10)};
    width: ${pxToRem(20)};
    height: ${pxToRem(20)};

    &:hover {
      opacity: 0.8;
    }
  }
`;

export const AddHomeworkWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${pxToRem(30)};
`;

export const ButtonWrapper = styled.div`
  margin-top: ${pxToRem(22)};
`;

export const EditableInput = styled.input`
  width: 100%;
  font-size: ${pxToRem(18)};
  font-weight: 400;
  color: rgb(31, 10, 53);
  border: ${pxToRem(1)} solid rgba(31, 10, 53, 0.2);
  border-radius: ${pxToRem(8)};
  padding: ${pxToRem(8)} ${pxToRem(12)};
  outline: none;
  border: none;
  background: none;
`;

export const FileDisplayWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: ${pxToRem(8)};
`;

export const DropArea = styled.div`
  border: ${pxToRem(2)} dashed rgba(114, 82, 220, 0.7);
  border-radius: ${pxToRem(12)};
  padding: ${pxToRem(20)};
  margin-top: ${pxToRem(20)};
  text-align: center;
  color: rgba(31, 10, 53, 0.7);
  cursor: pointer;

  &:hover {
    background-color: rgba(114, 82, 220, 0.05);
  }
`;

export const DragAndDropArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: ${pxToRem(20)};
  margin-bottom: ${pxToRem(20)};
  border: ${pxToRem(2)} dashed rgba(114, 82, 220, 0.5);
  border-radius: ${pxToRem(12)};
  background-color: rgba(114, 82, 220, 0.05);
  color: rgb(114, 82, 220);
  font-size: ${pxToRem(16)};
  font-weight: 500;
  text-align: center;
  cursor: pointer;

  &:hover {
    background-color: rgba(114, 82, 220, 0.1);
  }

  p {
    margin: 0;
  }
`;

export const VideoPlayersContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: ${pxToRem(10)};
  margin-top: ${pxToRem(20)};
  margin-bottom: ${pxToRem(20)};
`;